import "./consumptionCoverage.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";

import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend
);

function tableRender(tableData) {
  return (
    <div className="render-function">
      <table className="render-table">
        <thead>
          <tr>
            <td>Months</td>
            <td>PV Yeild kWh</td>
            <td>Montly Generation kWh</td>
            <td>Shading Losses kWh</td>
            <td>Tilt Angle Losses kWh</td>
            <td>Azimuth Angle Losses kWh</td>
            <td>Energy Losses Percentage</td>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item.month}</td>
                <td>{Number(item.montlyGeneration).toLocaleString("en-US")}</td>
                <td>{Number(item.actualGeneration).toLocaleString("en-US")}</td>
                <td>{Number(item.shadingLosses).toLocaleString("en-US")}</td>
                <td>{Number(item.tiltAngleLosses).toLocaleString("en-US")}</td>
                <td>{Number(item.azimuthLosses).toLocaleString("en-US")}</td>
                <td>{Number(item.percentage)}%</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function chartBallText(data) {
  return (
    <>
      {data.map((item, index) => {
        return (
          <div key={index} className="chart-ball-text">
            <div
              className="ball"
              style={{
                backgroundColor: item.backgroundColor,
                height: "15px",
                width: "15px",
                borderRadius: "50%",
              }}
            ></div>
            <p>{item.label}</p>
          </div>
        );
      })}
    </>
  );
}

const ConsumptionCoverage = (props) => {
  const { tableContent } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Energy Loss Analysis"
  );
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];

  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let montlyGeneration = [];
  let actualGeneration = [];
  let tiltAngleLosses = [];
  let azimuthLosses = [];
  let shadingLosses = [];

  if (check) {
    for (let j = 0; j < 12; j++) {
      let monthGen = 0;
      let actualGen = 0;
      let shadingLoss = 0;
      let azimuthLoss = 0;
      let tiltAngleLoss = 0;
      for (let i = 0; i < roofData.length; i++) {
        const element = roofData[i];
        monthGen += element.montlyGeneration[j];
        actualGen += element.actualGeneration[j];
        tiltAngleLoss += element.tiltAngleLosses[j];
        shadingLoss += element.shadingLosses[j];
        azimuthLoss += element.azimuthLosses[j];
      }
      montlyGeneration.push(monthGen);
      actualGeneration.push(actualGen);
      tiltAngleLosses.push(tiltAngleLoss);
      shadingLosses.push(shadingLoss);
      azimuthLosses.push(azimuthLoss);
    }
  } else {
    montlyGeneration = roofDetail.montlyGeneration;
    actualGeneration = roofDetail.actualGeneration;
    shadingLosses = roofDetail.shadingLosses;
    tiltAngleLosses = roofDetail.tiltAngleLosses;
    azimuthLosses = roofDetail.azimuthLosses;
  }

  let options1 = {
    responsive: false,

    plugins: {
      tooltip: {
        enabled: false, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Month", // X-axis title
        },
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 10 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Energy in kWh", // Y-axis title
        },
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  let state1 = {
    data: {
      labels: month,
      datasets: [
        {
          stack: "Stack 0",
          label: "Shading Losses",
          backgroundColor: "#045097",
          data: roofDetail.shadingLosses.map((item) => {
            return item;
          }),
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          stack: "Stack 1",
          label: "PV Yeild",
          backgroundColor: "#A0D4F5",
          data: roofDetail.montlyGeneration,
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          stack: "Stack 0",
          label: "Tilt Angle Losses",
          backgroundColor: "#CDDCEA",
          data: roofDetail.tiltAngleLosses.map((item) => {
            return item;
          }),
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          stack: "Stack 0",
          label: "Monthly Generation",
          backgroundColor: "#ff7f1e",
          data: roofDetail.actualGeneration,
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
      ],
    },
  };
  let percentage = Number(
    (100 - (actualGeneration[0] / montlyGeneration[0]) * 100).toFixed(1)
  );
  let generationAnalysis = [
    {
      month: "Jan",
      montlyGeneration: montlyGeneration[0],
      actualGeneration: actualGeneration[0],
      shadingLosses: shadingLosses[0],
      tiltAngleLosses: tiltAngleLosses[0],
      azimuthLosses: azimuthLosses[0],
      percentage: percentage,
    },
  ];
  for (let i = 1; i <= 11; i++) {
    const labels = month;
    percentage = Number(
      (100 - (actualGeneration[i] / montlyGeneration[i]) * 100).toFixed(1)
    );
    generationAnalysis.push({
      month: labels[i],
      montlyGeneration: montlyGeneration[i],
      actualGeneration: actualGeneration[i],
      shadingLosses: shadingLosses[i],
      tiltAngleLosses: tiltAngleLosses[i],
      azimuthLosses: azimuthLosses[i],
      percentage: percentage,
    });
  }

  return (
    <div id="consumption-coverage" className="consumption-coverage">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="ccg-body">
        <p style={{ marginTop: "30px", marginBottom: "20px" }}>
          Energy Loss Analysis
        </p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(generationAnalysis)}
        </div>
        <Bar
          height="220px"
          width="495px"
          options={options1}
          data={state1.data}
        />
        <div className="chart-ball-text-container">
          {chartBallText(state1.data.datasets)}
        </div>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default ConsumptionCoverage;
